import { render, staticRenderFns } from "./masterFileComplianceResources.vue?vue&type=template&id=44bd35d6&"
import script from "./masterFileComplianceResources.vue?vue&type=script&lang=js&"
export * from "./masterFileComplianceResources.vue?vue&type=script&lang=js&"
import style0 from "./masterFileComplianceResources.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "masterFileComplianceResources.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VFlex,
  VIcon,
})
